import { z } from 'zod';

// Log navigation
export const adminLogNavigationSchema = z.object({
    dateCreation: z.string(),
    action: z.string(),
    idUser: z.number(),
    pseudo: z.string(),
    level: z.number(),
    ip: z.string(),
    url: z.string(),
    extended: z.string().optional(),
});
export type AdminLogNavigation = z.infer<typeof adminLogNavigationSchema>;

// Log objects
export const adminLogObjectSchema = z.object({
    dateCreation: z.string(),
    action: z.string(),
    mainType: z.string(),
    idObject: z.number(),
    typeObject: z.string(),
    mail: z.string().optional(),
    url: z.string(),
    extended: z.string().optional(),
});
export type AdminLogObject = z.infer<typeof adminLogObjectSchema>;

// Log search
export const adminLogSearchSchema = z.object({
    dateCreation: z.string(),
    type: z.string(),
    msg: z.string(),
});
export type AdminLogSearch = z.infer<typeof adminLogSearchSchema>;
